import React, { useEffect, useState } from 'react';
import { Header, Button, Table } from 'react-frontier';
import { Seatmap } from '@arema/components';
import { Modal } from 'semantic-ui-react';
import { VenueSeat, SeatStatus, SetLoading } from '@arema/components/Classes';
import { formatSeatNumber } from '@arema/components/Util';
import API from '../ReportsAPI';

import '@arema/components/style/seatmap.scss';

interface UpdateSeatTicketProps {
	date_id: number,
	open: boolean,
	onClose: () => void,
	title?: string,
	onSave?: (l: SetLoading) => void,
}

interface SeatmapData {
	section_id: number,
	section_name: string,
	seats_width?: number,
	seats_height?: number,
	stage_x?: number,
	stage_y?: number,
	stage_width?: number,
	stage_height?: number,
	seatmap: VenueSeat[]
}

interface Section {
	section_id: number,
	section_name: string,
	tickets_sold: number,
}

function ViewSectionModal(props: UpdateSeatTicketProps) {
	var [loadError, setLoadError] = useState<string>(null);
	var [loadingSection, setLoadingSection] = useState<boolean>(false);
	var [sections, setSections] = useState<Section[]>(null);
	var [seatmap, setSeatmap] = useState<SeatmapData>(null);
	var [size, setSize] = useState<"small" | "mini" | "tiny" | "large" | "fullscreen">('mini');

	useEffect(() => {
		if (!props.open) return;

		loadSections();
	}, [props.open, props.date_id]);

	var loadSections = () => {
		// API.getDateSections(props.date_id).then(res => {
		// 	if (res.error) { setLoadError(res.message) }
		// 	setSections(res.data)
		// }).catch(() => {
		// 	setLoadError('Error inesperado cargando las secciones (LCL-1)');
		// });
	}

	var loadSection = (section_id: number) => {
		// setLoadingSection(true);
		// API.getDateSeatmap(props.date_id, section_id).then(res => {
		// 	if (res.error) return setLoadError(res.message);
		// 	setSize('large')
		// 	setSeatmap(res.data);
		// }).catch(err => {
		// 	return setLoadError('Hubo un error inesperado cargando el mapa de butacas (LCL-1)');
		// }).finally(() => {
		// 	setLoadingSection(false);
		// })
	}

	var onRowClick = (index: number) => {
		var sec = sections[index];
		if (sec) {
			loadSection(sec.section_id);
		}
	}

	var map: VenueSeat[][] = [];
	if (seatmap) {
		for (let y = 0; y < seatmap.seats_height; y++) {
			var row: VenueSeat[] = [];
			for (let x = 0; x < seatmap.seats_width; x++) {
				var seat = seatmap.seatmap.find(a => a.seat_x === x && a.seat_y === y);
				row.push(seat || null);
			}
			map.push(row);
		}
	}

	var has_stage = seatmap && seatmap.seats_height > 0 && seatmap.seats_width > 0 && seatmap.stage_x !== null && seatmap.stage_y !== null;

	return (
		<Modal open={props.open} onClose={props.onClose} size={size} >
			<Modal.Header>{seatmap ? seatmap.section_name : props.title}</Modal.Header>
			<Modal.Content>
				{((!sections && !seatmap) || loadingSection || loadError) ? (
					<div style={{ height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<Header loading={!loadError} text={loadError || 'Cargando mapa...'} iconName={loadError ? 'face-frown-open' : null} size={loadError ? 'small' : null} />
					</div>
				) : (
					<div>
						{seatmap ? (
							<div>
								<Seatmap initialScroll={Math.floor(seatmap.seats_width / 2) * 60}>
									{map.map((row, i) => (
										<Seatmap.Row seatAmount={seatmap.seats_width} key={`smprw-${i}`}>
											{row.map((seat, si) => {
												var key = `smpst-${i}-${si}`
												var is_stage = has_stage && seatmap.stage_x <= si && (seatmap.stage_x + seatmap.stage_width) > si && seatmap.stage_y <= i && (seatmap.stage_y + seatmap.stage_height) > i;
												if (is_stage) {
													if (si != seatmap.stage_x) return null;
													var stage_row = i - seatmap.stage_y;
													var is_center = Math.max(Math.min(Math.floor(seatmap.stage_height / 2), seatmap.stage_height), 0) == stage_row;
													var is_top = i == seatmap.stage_y, is_bottom = i == (seatmap.stage_y + seatmap.stage_height - 1);

													return <Seatmap.Seat key={key} stage={[
														is_top ? 1 : 0, is_top ? 1 : 0,
														is_bottom ? 1 : 0, is_bottom ? 1 : 0,
													]} size={seatmap.stage_width} width={64} height={is_top || is_bottom ? 42 : 44} style={{
														marginTop: is_top ? 2 : 0,
														marginLeft: 0,
														marginRight: 0
													}}>
														{is_center ? 'Escenario' : null}
													</Seatmap.Seat>
												} else if (!seat) {
													return <Seatmap.Seat empty key={key} />
												} else

													return <Seatmap.Seat
														key={key}
														color={seat.seat_status !== SeatStatus.FREE ? 'red' : (!!seat.ticket_id ? 'green' : 'gray')}
														subtext={seat.seat_section}
													>
														{seat.seat_status === SeatStatus.LOCKED ? (
															<i className='icon lock'></i>
														) : null}
														{formatSeatNumber(seat.seat_row, seat.seat_number)}
													</Seatmap.Seat>
											})}
										</Seatmap.Row>
									))}
								</Seatmap>
							</div>
						)
							:
							<Table
								selectable
								divided
								striped
								onClick={(v, i) => { onRowClick(i) }}
								data={sections.map(s => {
									return [s.section_name, s.tickets_sold];
								})}
							/>
						}
					</div>
				)}
			</Modal.Content>
			<Modal.Actions>
				<Button basic text='Cerrar' onClick={props.onClose} />
				{
					props.onSave &&
					<Button color="black" text='Guardar' onClick={props.onSave} />
				}
			</Modal.Actions>
		</Modal>
	)
}

export default ViewSectionModal
